import { render, staticRenderFns } from "./BarangayVotersChart.vue?vue&type=template&id=76e2ec7e&scoped=true"
import script from "./BarangayVotersChart.vue?vue&type=script&lang=js"
export * from "./BarangayVotersChart.vue?vue&type=script&lang=js"
import style0 from "./BarangayVotersChart.vue?vue&type=style&index=0&id=76e2ec7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2ec7e",
  null
  
)

export default component.exports